<template>
    <div class="search">
        
        <input class="" type="text" :placeholder="placeholder" v-model="term" v-if="!selected_term">
        <div v-else class="pseudo-input">
            <div class="selected-term">{{selected_term}} </div> <div class="btn-close" @click="() => term_selected(null)">✕</div>
        </div>

        <div class="suggestions" v-if="show_suggestions && !selected_term">
            
            <template v-if="suggestions.items.length > 0"> 

                <!-- TODO тут потрібно засетити selected_term і повернути нагору інфу про це -->
                <a v-for="s in suggestions.items" :key="s.text" 
                    v-html="render_match(s.text, term)"
                    @click="term_selected(s.text)" 
                > 
                </a>

                <div class="supressed" v-if="suggestions.hidden >0 "> ...а також ще {{ suggestions.hidden }} співпадінь ...</div>
            </template>

            <div v-else>Нічого не знайдено</div>
        </div>


    </div>
</template>

<script>
export default {
    name: "Search",
    props: ["search_index", "placeholder"],

    data() {
        return {
            term: "",
            selected_term: null,
        }
    },

    computed: {
        show_suggestions() {
            return this.term.trim().length >= 3;
        },

        suggestions() {
            let items = this.search_index.filter(e => e.text.toLowerCase().includes(this.term.toLowerCase()))

            return {
                items: items.slice(0, 10),
                total: items.length,
                hidden: items.length <= 10 ? 0 : items.length - 10 
            }
        }
    },

    methods: {
        render_match(text, term) {
            let m = text.toLowerCase().match(RegExp(term.toLowerCase())) 

            let start_idx = m.index
            let end_idx = start_idx + term.length
            
            let start = text.substring(0, start_idx)
            let match = text.substring(start_idx, end_idx)
            let end = text.substring(end_idx)
            
            return `${start}<span class="match">${ match }</span>${end}`;
        },

        term_selected(term) {
            this.selected_term = term;
            this.term = '';
            this.$emit('term_selected', term);
        },
    }
}
</script>


<style lang="scss" scoped>

.search {

    position: relative;

    font-size: 1em !important;
    border-radius: 0;
    font-weight: 300 !important;
    // overflow: hidden;

    input, .pseudo-input {
        background: var(--col-grey);  
        font-weight: 300 !important;
        width: 100%;

        color: black !important;
        height: 100%;
        border-radius: 0;
        border: none;        

        font-size: 1rem;
        padding-left: 0.3rem;
    }

    .pseudo-input {
        display: flex;
        align-items: center;

        .selected-term {
            background-color: var(--col-orange);
            border-radius: 0.25rem;
            padding: 0 0.5em;
            color: white;
            font-weight: 600;

        }

        .btn-close {
            background-color: var(--col-orange);
            width: 1.5em;
            height: 1.5em;
            line-height: 1.5em;
            text-align: center;
            border-radius: 50%;
            cursor: pointer;
            margin-left: 0.25em;

            &:hover {
                background-color: black;
                color: white;
            }
        }
    }

    input::placeholder {
        opacity: 0.5;
    }

    .suggestions {
        display: flex;
        flex-direction: column;
        background-color: white;
        color: black;
        width: 100%;
        z-index: 1000;

        // border: 1px solid black;
        border-top: none;
        position: absolute;
        top: 100%;

        font-size: 1rem;

        > * {
            padding-left: 0.3rem;
        }

        a {
            cursor: pointer;
            padding: 0.3rem;
            // padding-left: 0.3rem;
            text-decoration: none;

            &:hover {
                background-color: #e7eef3;
            }

            ::v-deep .match {
                font-weight: 600;
            }
        }

        .supressed {
            color: rgb(90, 90, 90);        
            display: flex;
            flex-direction: column;
            background-color: white;
            color: black;
            width: 100%;

            border: 1px solid white;
            position: absolute;
            top: 100%;

            // font-size: 1rem;

            > * {
                padding-left: 0.3rem;
            }

            a {
                padding-left: 0.3rem;
                text-decoration: none;
                padding: 1em;

                &:hover {
                    background-color: var(--col-salmon);
                }

                ::v-deep .match {
                    font-weight: 700;
                }
            }
        }
    }
}
</style>